import React, {useMemo, useReducer, useState} from "react";
import { Button } from "@mui/material";

import {InputText} from "../../_components/InputText/InputText";
import styles from "../../_components/Styles/BaseStyleForAdminPanel.module.css";
import {PositionCreate} from "../../../../types/api/authorization/position.types";
import {useFetchAllRights} from "../../../../hooks/authorization/useFetchAllRights";
import {useFetchAllFullInfoUser} from "../../../../hooks/authorization/useFetchAllFullInfoUser";
import {getFullName} from "../../../../utils/nameFormatter";
import {positionService} from "../../../../services/authorization/position-service";
import useAppSnackbar from "../../../../hooks/useAppSnackbar";
import OpenCheckboxList from "../../_components/OpenCheckboxList/OpenCheckboxList";


export const CreatePosition = () => {
    const {showSuccess, showError, SnackbarComponent} = useAppSnackbar();
    const initialState: PositionCreate = {
        name: "",
        rights: [],
        users: [],
    };

    const {
        data: dataRight,
    } = useFetchAllRights();

    const {
        data: usersData
    } = useFetchAllFullInfoUser();

    const reducer = (state: PositionCreate, action: any) => {
        switch (action.type) {
            case "SET_FIELD":
                return {...state, [action.name]: action.value} as PositionCreate;
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(reducer, initialState);

    const handleValue = (event: any) => {
        dispatch({
            type: "SET_FIELD",
            name: event.target.name,
            value: event.target.value
        });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await positionService.create(state);
            showSuccess("Должность сохранена")
        } catch (e) {
            showError("Ошибка при создании должности")
        }
        console.log("Submitting:", state);
    };

    const [rightsSearch, setRightsSearch] = useState<string>("");
    const [usersSearch, setUsersSearch] = useState<string>("");

    const filteredRights = useMemo(() => {
        const q = rightsSearch.trim().toLowerCase();
        if (!q) return dataRight ?? [];
        return (dataRight ?? []).filter(r => (r.title ?? "").toLowerCase().includes(q));
    }, [rightsSearch, dataRight]);

    const filteredUsers = useMemo(() => {
        const q = usersSearch.trim().toLowerCase();
        if (!q) return usersData ?? [];
        return (usersData ?? []).filter(u => getFullName(u).toLowerCase().includes(q));
    }, [usersSearch, usersData]);

    return (
        <form className={styles.formWrapper} onSubmit={handleSubmit}>
            <div className={styles.formCard}>
                <div className={styles.formHeader}>
                    <h2 className={styles.formTitle}>Создание новой должности</h2>
                    <p className={styles.formSubtitle}>Заполните информацию о должности</p>
                </div>

                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h3 className={styles.sectionTitle}>Общая информация</h3>
                    </div>
                    <div className={styles.inputsGrid}>
                        <div className={styles.fullRow}>
                            <InputText
                                name="name"
                                value={state.name}
                                handleValue={handleValue}
                                label="Название"
                                idField="name"
                                required={true}
                            />
                        </div>
                    </div>
                    <hr className={styles.sectionDivider} />
                </div>

                <div className={styles.section}>
                    <div className={styles.inputsGrid}>
                        <OpenCheckboxList
                            label="Права"
                            name="rights"
                            options={(filteredRights ?? []).map(r => ({ value: r.id, label: r.title }))}
                            selected={state.rights as string[]}
                            onChange={handleValue}
                            searchValue={rightsSearch}
                            onSearchChange={setRightsSearch}
                        />
                    </div>
                    <hr className={styles.sectionDivider} />
                </div>

                <div className={styles.section}>
                    <div className={styles.inputsGrid}>
                        <OpenCheckboxList
                            label="Сотрудники"
                            name="users"
                            options={(filteredUsers ?? []).map(u => ({ value: u.id, label: `${u.name} ${u.surname}` }))}
                            selected={state.users as string[]}
                            onChange={handleValue}
                            searchValue={usersSearch}
                            onSearchChange={setUsersSearch}
                        />
                    </div>
                </div>

                <div className={styles.btn}>
                    <Button
                        type="submit"
                        className={`${styles.buttonBase} ${styles.buttonPrimary}`}
                    >
                        Создать
                    </Button>
                </div>
            </div>

            <SnackbarComponent/>
        </form>
    );
};

export default CreatePosition;
